export default __webpack_public_path__ + "static/Will_SMFS-48b213bc915b77f5a7e7b1736c6ddb4a.pdf";